import styles from "./HistoriaEmpresa.module.css"
import React from "react";

function HistoriaEmpresa() {
    return (

        <div>
            <h1 className={styles['h1-historia-empresa']}>
                Sobre nosotros...
            </h1>

            <p className={styles['texto-historia-empresa']}>

                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolore pariatur dicta magnam deserunt itaque porro praesentium, quidem corporis nihil accusamus quaerat enim repellendus voluptatibus aperiam sunt tempora? Quisquam, recusandae sint.
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolore pariatur dicta magnam deserunt itaque porro praesentium, quidem corporis nihil accusamus quaerat enim repellendus voluptatibus aperiam sunt tempora? Quisquam, recusandae sint.
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolore pariatur dicta magnam deserunt itaque porro praesentium, quidem corporis nihil accusamus quaerat enim repellendus voluptatibus aperiam sunt tempora? Quisquam, recusandae sint.
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolore pariatur dicta magnam deserunt itaque porro praesentium, quidem corporis nihil accusamus quaerat enim repellendus voluptatibus aperiam sunt tempora? Quisquam, recusandae sint.

            </p>

        </div>

    )
}

export default HistoriaEmpresa;